<cadastre-data-import-form (importAdded)="onImportAdded($event)"></cadastre-data-import-form>
<cadastre-data-import-list [newImport]="newImport"></cadastre-data-import-list>
